import React from "react";

export default function Stats({ data }) {
  if (!data) return null;
  return (
    <section className="stats" aria-label="Key statistics">
      <div className="wrap stats-grid">
        {data.map((s, i) => (
          <div key={i} className="stat">
            <div className="stat-value">{s.value}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
